const language = typeof LANGUAGE !== 'undefined' && LANGUAGE ? LANGUAGE : 'fr'; // eslint-disable-line no-undef

const messages = await import(`../../../../../translations/messages_front.${language}.json`);
const validators = await import(`../../../../../translations/validators.${language}.json`);

export default function () {
  return {
    messages: messages.default,
    validators: validators.default,
  };
}
